import { useCallback, useEffect, useState } from "react";
import { apiCallsParking } from "../api/calls/parking";

export const useParkingDeviceStatuses = () => {
  const [deviceStatuses, setDeviceStatuses] = useState([]);

  const loadDeviceStatuses = useCallback(async () => {
    const statuses = await apiCallsParking.Actions.GetDeviceStatuses();
    setDeviceStatuses(statuses);
  }, []);

  useEffect(() => {
    loadDeviceStatuses();
  }, [loadDeviceStatuses]);

  return { deviceStatuses, loadDeviceStatuses };
};
